var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');
require('owl.carousel/dist/assets/owl.carousel.css');
require('owl.carousel');
require('animate.css');
var imagesLoaded = require('imagesloaded');
require('jquery.dotdotdot');
var FontFaceObserver = require('fontfaceobserver');

require('front/components/CommentCount/CommentCount');
require('front/components/Category/Category');
require('front/components/ViewCount/ViewCount');
var RecentNews = require('front/components/RecentNews/RecentNews');
require('./Favorites.less');

var CheckDevice = require('front/utils/CheckDevice/CheckDevice');

module.exports = Backbone.View.extend({
    events: {
        'click .owl-dot': 'changeSlide'
    },

    initialize: function (options) {
        _.bindAll(this, 'checkLazyLoading');

        this.initSlider();
        this.initTitles();

        new RecentNews();
    },

    initSlider: function () {
        var self = this;

        this.$itemInfo = this.$('.Favorites-item-info');
        this.$itemInfo.eq(0).addClass('isShown');

        this.$slides = this.$('.FavoritesItem');
        this.initialImagesLoadedCount = 0;

        this.isHighDensity = CheckDevice.isHighDensity();

        app.vent.on('favorites:initial-images-loaded', function () {
            self.startSliderAutoplay();
        });

        this.$carousel = this.$('.Favorites-content');

        this.$carousel.on('initialized.owl.carousel', function () {
            self.slidesLength = self.$slides.length;
            self.countActivated = 0;
            self.lazyLoaded = false;
            self.$owlSlides = self.$('.owl-item');
        });

        this.$carousel.owlCarousel({
            items: 1,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            mouseDrag: false,
            loop: false,
            nav: false,
            dots: true,
            autoplay: false,
            autoplayTimeout: 5000,
            autoplaySpeed: 800,
            dragEndSpeed: 800,
            dotsSpeed: 500
        })
            .on('changed.owl.carousel', function (evt) {
                self.slideIndex = evt.item.index; //Номер слайда учитывая клонов
                self.pageIndex = evt.page.index; //Номер слайда не учитывая склонированные элементы

                self.checkLazyLoading(evt);
            })
            .on('translate.owl.carousel', function () {
                self.$itemInfo.removeClass('isShown');
            })
            .on('translated.owl.carousel', function (evt) {
                var currentItem = $(evt.target).find('.owl-item')
                    .eq(self.slideIndex);
                self.$itemInfo.removeClass('isShown');
                currentItem.find(self.$itemInfo).addClass('isShown');
            });

        this.$carousel.trigger('stop.owl.autoplay');

        var $initialImages = this.$slides.slice(1, 2);
        var retina = this.isHighDensity;

        $initialImages.each(function () {
            var $image = $(this).find('img');
            var $img = $('<img>');

            $img.attr('src', $image.attr('data-src' + (retina ? '-retina' : '')));
        });

        imagesLoaded($initialImages.toArray(), function () {
            window.app.vent.trigger('favorites:initial-images-loaded');
        });
    },

    // Проверка загруженности картинок по мере переключения
    checkLazyLoading: function (evt) {
        if (this.lazyLoaded) {
            this.$carousel.off('changed.owl.carousel', this.checkLazyLoading.bind(this));

            return;
        }

        var index = evt.item.index;
        var $nextSlide = this.$slides.eq(index + 1);
        var $prevSlide = this.$slides.eq(index - 1);

        this.activeSlide(this.$slides.eq(index));

        if ($nextSlide.length) {
            this.activeSlide($nextSlide);
        }

        if ($prevSlide.length) {
            this.activeSlide($prevSlide);
        }
    },

    activeSlide: function ($el) {
        var $img = $el.find('img');

        if (!$img.data('init-slide')) {
            $img.data('init-slide', true);
            $img.removeClass('owl-lazy');

            this.countActivated += 1;

            var url = $img.attr('data-src' + (this.isHighDensity ? '-retina' : ''));
            $img.attr('src', url);

            if (this.countActivated === this.slidesLength) {
                this.lazyLoaded = true;
            }
        }
    },

    startSliderAutoplay: function () {
        this.$carousel.trigger('play.owl.autoplay');
    },

    changeSlide: function (e) {
        // var $dot = $(e.target).closest('.owl-dot');

        this.$carousel.trigger('stop.owl.autoplay');
    },

    initTitles: function () {
        var fontRaleway = new FontFaceObserver('Raleway', {
            weight: 800
        });

        var fontOpenSans = new FontFaceObserver('Open Sans', {
            weight: 400
        });

        Promise.all([fontRaleway.load(), fontOpenSans.load()]).then(function () {
            this.$('.FavoritesItem-title').dotdotdot();
            this.$('.FavoritesItem-text').dotdotdot();
        }.bind(this));
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Favorites/Favorites.js
// module id = 173
// module chunks = 0